// What this browser can do.

/** Screen sharing needs getDisplayMedia (missing on phones, e.g. iOS Safari). */
export function canShareScreen(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.mediaDevices?.getDisplayMedia === 'function';
}
